import React from 'react'
import { MODO_TESTE } from '../config/modoTeste'

// Avisos do modo de testes. Não renderizam nada se MODO_TESTE = false.

export function FaixaTeste() {
  if (!MODO_TESTE) return null
  return (
    <div role="status" style={{
      background: '#F59E0B',
      color: '#1F1300',
      textAlign: 'center',
      fontSize: '13px',
      fontWeight: 600,
      padding: '8px 16px',
      lineHeight: 1.4,
    }}>
      Site de demonstração. As marcações feitas aqui não são reais.
    </div>
  )
}

export function NotaTeste({ children, style }) {
  if (!MODO_TESTE) return null
  return (
    <div role="note" style={{
      background: '#FEF3C7',
      border: '1px solid #F59E0B',
      color: '#78350F',
      borderRadius: 'var(--raio)',
      padding: '12px 16px',
      fontSize: '14px',
      lineHeight: 1.5,
      textAlign: 'left',
      ...style,
    }}>
      <strong>Atenção:</strong> {children}
    </div>
  )
}
